import React from 'react';
export function Footer() {
  return <footer className="bg-card-bg border-t border-[rgba(107,0,182,0.3)] py-[30px] px-5 text-center" data-id="element-47" data-mp="32wd0e9mw79qd">
      <p className="text-[0.8rem] text-white/35 leading-[1.8]" data-id="element-48" data-mp="3ggtxuh7dth4p">
        © 2025 Dr. Eduardo Ortiz — PLACER, CULPA Y VACÍO · El Camino a la
        Recuperación
        <br data-id="element-49" data-mp="36oy05797jt10" />
        <a href="#" className="text-white/40 no-underline hover:text-magenta-bright transition-colors" data-id="element-50" data-mp="36qhhl16loa4d">
          Términos y condiciones
        </a>{' '}
        ·{' '}
        <a href="#" className="text-white/40 no-underline hover:text-magenta-bright transition-colors" data-id="element-51" data-mp="38h5b9u0hiky">
          Política de privacidad
        </a>{' '}
        ·{' '}
        <a href="#" className="text-white/40 no-underline hover:text-magenta-bright transition-colors" data-id="element-52" data-mp="3lggcmv2uz5fm">
          Contacto
        </a>
      </p>
    </footer>;
}